import { render, staticRenderFns } from "./ReviewLikes.vue?vue&type=template&id=5c9846a2&scoped=true&"
import script from "./ReviewLikes.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewLikes.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewLikes.vue?vue&type=style&index=0&id=5c9846a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9846a2",
  null
  
)

export default component.exports